<template>
  <v-layout column>
    <v-layout
      v-if="totalItems"
      class="pa-4"
      column
    >
      <v-card
        class="application-item mb-4"
        v-for="(subpoena, index) in subpoenas"
        :key="index"
      >
        <v-toolbar color="teal darken-4" dark>
          <v-toolbar-side-icon left>{{subpoena.application_type.acronym}}</v-toolbar-side-icon>
          <v-toolbar-title>Intimação: {{subpoena.application_type.name}}</v-toolbar-title>
          <v-spacer />
          <span class="mr-3" v-if="subpoena.folder_number != undefined">
            Processo: {{subpoena.folder_number}}
          </span>
          <v-list-tile-action right>
            <small class="badge red darken-1">
              {{ subpoena.intimations.length }} {{ subpoena.intimations.length > 1 ? " Intimações" : " Intimação"}}
            </small>
          </v-list-tile-action>
        </v-toolbar>

        <v-list two-line subheader>
          <v-list-tile avatar @click="showApplication(subpoena)">
            <v-list-tile-avatar>
              <v-icon>{{ personalTypeIcon(subpoena) }}</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{subpoena.person.name}}</v-list-tile-title>
              <v-list-tile-sub-title>
                {{ processCpfCnpj(subpoena.person) }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>

      <v-layout
        v-if="totalPages"
        justify-center
        align-center
      >
        <v-pagination class="align-self-center"
          color="teal darken-4"
          v-model="activePage"
          :length="totalPages"
          total-visible="5"
          circle
        />
      </v-layout>
    </v-layout>

    <v-card v-if="!subpoenas.length">
      <v-card-text>
        <v-layout
          class="empty-list"
          justify-center
          align-center
          column
        >
          <img
            class="mb-3 icon"
            src="@/assets/image/icon/leaf.svg"
            alt="Ícone Ambiental"
            width="320"
          >
          <h1 class="heading">Não há intimações para exibir</h1>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import CPF_CNPJ from 'cpf_cnpj';

export default {
  name: 'SubpoenasList',
  props: {
    subpoenas: {
      type: Array,
      default: () => [],
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    totalItems: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activePage: this.page,
    }
  },
  methods: {
    showApplication(subpoena) {
      this.$store.dispatch('setLoadingDialog', true);
      // Caminho absoluto: a tela de intimações do admin agora vive fora de
      // /admin/requerimentos/lista, então push relativo não resolveria certo.
      const base = this.$route.meta.userAlias === 'admin'
        ? '/admin/requerimentos'
        : '/requerente/requerimentos';
      this.$router.push(`${base}/${subpoena.id}/visualizar`);
    },
    personalTypeIcon(subpoena) {
      return subpoena.person.person_type === 'physical_person' ? 'mdi-account' : 'mdi-domain';
    },
    processCpfCnpj(person) {
      if (person.person_type === 'physical_person') {
        return `CPF: ${CPF_CNPJ.CPF.format(person.cpf_cnpj)}`;
      }
      return `CNPJ: ${CPF_CNPJ.CNPJ.format(person.cpf_cnpj)}`;
    },
  },
  watch: {
    activePage() {
      this.$emit('changePage', this.activePage);
    }
  }
};
</script>
